import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import * as React from "react";
import { ReactComponent as AccountExistsIcon } from "../../../../assets/SelfReg-AccountExistsIcon.svg";

const offsetStyle = "72px";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    height: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      height: `calc(100vh - ${offsetStyle})`,
      minHeight: `calc(100vh - ${offsetStyle})`,
    },
  },
  headerIcon: {
    marginTop: "4rem",
  },
  header: {
    fontWeight: "bold",
    fontSize: 30,
    marginTop: "2.5rem",
  },
  subHeader: {
    fontSize: 16,
    marginTop: "1rem",
    marginBottom: "2.5rem",
    maxWidth: 582,
  },
  linkMaroon: {
    textDecoration: "underline",
    color: "#8c1d40",
    cursor: "pointer",
    background: "none",
    border: "none",
  },
}));

const opaqueStyle = {
  backgroundColor: "#fafafa",
  color: "#000000E6",
};

interface AccountExistsProps {
  children?: any;
}

export const AccountExists = (props: AccountExistsProps) => {
  const classes = useStyles();
  let { children } = props;
  return (
    <div className={classes.container} style={opaqueStyle}>
      <div className={classes.headerIcon}>{<AccountExistsIcon />}</div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}>
        <Typography
          component="span"
          variant="h3"
          sx={{
            fontWeight: "bold",
            fontSize: 30,
            marginTop: "3rem",
            alignItem: "left",
            minWidth: "582px",
          }}>
          Your account already exists
        </Typography>
      </Box>
      <Typography
        component="main"
        className={classes.subHeader}
        variant={"body1"}
        sx={{ fontWeight: 400 }}>
        <>
          It looks like you’ve already created an account with the email used in sign up.
          Please log in or reset your password in the log in page.
        </>
      </Typography>
      {children}
    </div>
  );
};
